import React from "react"
import moment from "moment"

import SourceStatusButton from "../sources/SourceStatusButton"

const NotificationStatus = ({ expires, not_before, style }) => {
    const isExpired = expires && expires.isBefore(moment())
    const hasntStartedYet = not_before && not_before.isAfter(moment())
    let buttonText = "Active"
    if (isExpired) {
        buttonText = "Expired"
    } else if (hasntStartedYet) {
        buttonText = "Not started"
    }
    return (
        <SourceStatusButton
            active={!isExpired && !hasntStartedYet}
            style={style}
        >
            {buttonText}
        </SourceStatusButton>
    )
}

export default NotificationStatus
